/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useLegacyRouter } from '@/hooks/useLegacyRouter';
import { getLocationsParams } from '../utils/getLocationsParams';
import { useLocale } from '@/hooks/useLocale';

export const useLocationsParams = () => {
  const { query } = useLegacyRouter();
  const locale = useLocale();

  return getLocationsParams(locale, query);
};
